// client/src/dnd/emitter_tool/utils/modeSwitch.js
const UI_FIRE_MODE_KEY        = "EmitterTool:UI:fireMode";          // "off" | "infinite" | "timed" | "rule"
const UI_TARGETING_PRESET_KEY = "EmitterTool:UI:targetingPresetV1"; // "point", ...

function dispatch(name, detail) {
  try { window.dispatchEvent(new CustomEvent(name, { detail })); } catch {}
}

function setLS(key, val) {
  try { localStorage.setItem(key, String(val)); } catch {}
}

/**
 * One-liner mode switch.
 * id: "origin-direction" | "origin-target"
 * opts: { timedSeconds?: number, pointRangeM?: number }
 */
export function setEmitterMode(id, opts = {}) {
  const mode = String(id || "").toLowerCase();

  if (mode === "origin-direction") {
    setLS(UI_FIRE_MODE_KEY, "infinite");
    setLS(UI_TARGETING_PRESET_KEY, "");
    dispatch("EmitterTool:ModeChange", { mode: "infinite" });
    dispatch("EmitterTool:UI:TargetingPreset", { presetId: "" });
    // restore overlay preview behavior if any UI listens
    dispatch("EmitterTool:UI:OverlayVisible", { visible: true });
    return;
  }

  if (mode === "origin-target") {
    // rule + "point" preset (your PointToTarget module listens for these)
    setLS(UI_FIRE_MODE_KEY, "rule");
    setLS(UI_TARGETING_PRESET_KEY, "point");
    if (Number.isFinite(opts.timedSeconds)) {
      try { localStorage.setItem("EmitterTool:UI:timedDur", String(Math.max(0, opts.timedSeconds))); } catch {}
    }
    if (Number.isFinite(opts.pointRangeM)) {
      try { localStorage.setItem("EmitterTool:UI:pointRangeM", String(Math.max(0, opts.pointRangeM))); } catch {}
    }
    dispatch("EmitterTool:ModeChange", { mode: "rule" });
    dispatch("EmitterTool:UI:TargetingPreset", { presetId: "point" });
    return;
  }

  // fallback: leave as-is but announce
  dispatch("EmitterTool:ModeChange", { mode: localStorage.getItem(UI_FIRE_MODE_KEY) || "infinite" });
}

/** Convenience one-liners if you prefer named calls */
export const setOriginDirection = () => setEmitterMode("origin-direction");
export const setOriginTarget = (opts) => setEmitterMode("origin-target", opts);

/** Optional: expose a tiny window API for quick manual triggering/devtools */
try {
  window.EmitterToolMode = {
    set: setEmitterMode,
    originDirection: setOriginDirection,
    originTarget: setOriginTarget,
  };
} catch {}
